export const isMobile = () => {
  console.log(window.innerWidth, window.innerHeight);
  if (window.innerWidth <= 1280) {
    return true;
  } else {
    return false;
  }
};
import { Doughnut } from 'vue-chartjs'
export default {
  extends: Doughnut,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    appDrawer: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ""
    },
    default_currency: {
      type: String,
      default: ""
    }

  },

  data: () => ({
    gradient: null,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      aspectRatio: .5,
      mainPieSize: 0.5,
      position: 'right',
      title: {
        display: false,
        position: 'top',
        text: "",
        fontStyle: 'bold',
        padding: 5,
        align: 'start'
      },
      cutoutPercentage: 80,
      percentageInnerCutout: 80,

      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            return Number(data['datasets'][0]['data'][tooltipItem['index']]).toFixed(2) + ' '+window.b2b_default_currency;
          },

        },

        titleFontSize: 16,
        bodyFontSize: 14,
        displayColors: true
      },
      legend: {
        display: false,
        position: isMobile() ? 'left' : 'chartArea',
        align: 'center',
        boxWidth: 200,

        labels: {
          usePointStyle: true,
          boxWidth: 200,


        }
      },
      scales: {

      }

    }
  }),

  mounted() {
    console.log({ chartdata: this.chartdata, options: this.options })
    this.renderChart(this.chartdata, this.options)
  },


}